import {MoneyRequest} from 'pages/Portal/ClientInboxItem/types';
import {useRef, useState} from 'react';
import {t} from 'ttag';

const usePaymentPanel = (moneyRequest: MoneyRequest) => {
    const [error, setError] = useState<null | string>();
    const [isPaid, setIsPaid] = useState<boolean>(moneyRequest.paid);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const pollCount = useRef<number>(0);

    const setGenericError = () => {
        setError(
            t`There seems to be something wrong with our payment system at the moment, please try again in a couple of minutes. If this problem persists, please contact us at support@makeleaps.com`,
        );
    };
    const setTimeoutError = () => {
        setError(
            t`Our payment systems seem to be overloaded at the moment. Please try again in a couple of minutes. If the problem persists, please contact us at support@makeleaps.com`,
        );
    };

    const clearError = () => {
        setError(null);
    };

    return {
        clearError,
        error,
        isLoading,
        isPaid,
        pollCount,
        setError,
        setGenericError,
        setIsLoading,
        setIsPaid,
        setTimeoutError,
    };
};

export default usePaymentPanel;
